import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';
import { push } from 'connected-react-router';

import { UPLOAD_CSV_CLIENTS } from '../types/uploadCsvClientsTypes';
import { uploadCsvClientsFulfilled, uploadCsvClientsPending, uploadCsvClientsRejected } from '../actions/uploadCsvClientsActions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifyError, notifySuccess } from '../../../actions';
import { UPLOAD_CSV_CLIENTS_MESSAGES } from '../constants/uploadCsvClientsMessages';
import routesConfig from '../../../routes/routes-config';
import generateError from '../../../utilities/generateError';

const uploadPayload = payload => ({
  method: 'post',
  url: 'scorecard/importclientscsv',
  onSuccess: [
    uploadCsvClientsFulfilled,
    () => notifySuccess(UPLOAD_CSV_CLIENTS_MESSAGES.CREATED),
    () => push(routesConfig.uploadCsvClientsPage.path),
  ],
  onError: [
    uploadCsvClientsRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'formDataApi',
};

const uploadCsvClientsEpic$ = action$ => action$.pipe(
  ofType(UPLOAD_CSV_CLIENTS.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(uploadCsvClientsPending()),
    of(sendApiRequest(uploadPayload(payload), meta)),
  )),
);

export default uploadCsvClientsEpic$;


// WEBPACK FOOTER //
// ./src/features/score-card/epics/uploadCsvClientsEpic.js